import { z } from 'zod'

export const numberEnum = <Num extends number, T extends Readonly<Num[]>>(args: T): z.ZodSchema<T[number]> => {
  const [first, ...rest] = args
  if (rest.length === 0) {
    return z.literal(first) as z.ZodSchema<T[number]>
  }
  return z.union([z.literal(first), ...rest.map((v) => z.literal(v))] as [
    z.ZodLiteral<T[number]>,
    z.ZodLiteral<T[number]>,
    ...z.ZodLiteral<T[number]>[],
  ]) as z.ZodSchema<T[number]>
}

export const transformNumberEnumToStringEnum = <T extends number>(value: T): NumberEnumToStringEnum<T> => {
  return value.toString() as NumberEnumToStringEnum<T>
}
